import { connect } from "react-redux";
import React, { useState, useEffect } from "react";
import { DatePicker, Input, InputNumber, Select } from "antd";
import { sortBy, isEmpty } from "lodash";
import moment from "moment";

import { BONUS_TYPE_ID, FREQUENCY_ID, FREQUENCY_ID_TO_LABEL } from "./../../../configs/constants";
import ConfirmButton from "../../../components/buttons/ConfirmButton";
import { fetchUsersSectors } from "../../../modules/presence/actions/expenseReports";
import { createBonus } from "./../../../modules/presence/api/api";
import { get } from "../../../modules/presence/utils/utils";
import { isBonusFormValid } from "./Premium.utils";

const PremiumForm = ({
  getMatchParams,
  selectedClient,
  action,
  premiumSelected = null,
  selectedTypeId,
  fetchPremiums,
  closeModal,
  getUsersSectors,
  userRoleId,
  userClientsIds,
  usersSectors,
  token
}) => {
  useEffect(() => {
    if (isEmpty(usersSectors))
      getUsersSectors({
        match: {
          role_id: { $gt: userRoleId },
          "clients.id": userClientsIds ? userClientsIds : []
        }
      });
  }, []);

  const [user, setUser] = useState(null);
  const [amount, setAmount] = useState(0);
  const [dateSelected, setDateSelected] = useState(moment().subtract(1, "month"));
  const [selectedFrequencyId, setSelectedFrequencyId] = useState(FREQUENCY_ID.MONTHLY);
  const [errorText, setErrorText] = useState(null);
  const [comment, setComment] = useState("");

  useEffect(() => {
    if (premiumSelected) {
      setUser(premiumSelected.user_email);
      setAmount(premiumSelected.amount);
      setComment(premiumSelected.comment);
      setDateSelected(moment(premiumSelected.start_date));
      setSelectedFrequencyId(premiumSelected.frequency_id);
    }
    setErrorText(null);
  }, [premiumSelected]);

  const resetFields = () => {
    setUser(null);
    setAmount(0);
    setComment("");
    setDateSelected(moment());
  };

  const handleCreateUpdatePremium = async () => {
    const dataToSend = {
      start_date: dateSelected,
      user_email: user,
      type_id: selectedTypeId,
      frequency_id: selectedFrequencyId,
      amount,
      comment: selectedTypeId === BONUS_TYPE_ID.EXTRA ? comment : "prime normale"
    };

    if (action === "update" && premiumSelected) dataToSend._id = premiumSelected._id;
    {
      setErrorText(null);
    }
    try {
      isBonusFormValid(dataToSend);
      await createBonus(dataToSend, token);

      resetFields();
      fetchPremiums({
        match: {
          ...getMatchParams,
          ["clients.label"]: selectedClient
        }
      });
      closeModal();
    } catch (e) {
      const field = get(["response", "data", "data", "fields", 0], e);
      if (field) {
        const message = get(
          ["response", "data", "data", "e", field, "message"],
          e,
          "la requète n'a pu aboutir, veuillez reassayer"
        );
        setErrorText(message);
      } else if (e.response && e.response.data && typeof e.response.data.data === "string")
        setErrorText(e.response.data.data);
      else {
        setErrorText(e.message);
      }
    }
  };

  return (
    <div>
      {errorText && <div className="font-bold text-red-400 mb-10">{errorText}</div>}
      <div className="flex justify-between items-center mb-4">
        <div className="">Personne :</div>
        <Select
          disabled={action === "update"}
          value={user}
          showSearch
          placeholder="Choisir un utilisateur"
          style={{ width: 300 }}
          onChange={setUser}
        >
          {usersSectors &&
            sortBy([...usersSectors], [userItem => userItem.fullName]).map(item => (
              <Select.Option key={item._id} value={item.email}>
                {item.fullName}
              </Select.Option>
            ))}
        </Select>
      </div>
      {selectedTypeId === BONUS_TYPE_ID.REGULAR && (
        <div className="flex justify-between items-center mb-4">
          <div className="">Fréquence :</div>
          <Select value={selectedFrequencyId} style={{ width: 300 }} onChange={setSelectedFrequencyId}>
            {Object.entries(FREQUENCY_ID_TO_LABEL).map(([key, value]) => (
              <Select.Option key={key} value={Number(key)}>
                {value}
              </Select.Option>
            ))}
          </Select>
        </div>
      )}
      <div className="flex justify-between items-center mb-4">
        <div className="">Période :</div>
        <DatePicker.MonthPicker
          format={"MMMM"}
          onChange={setDateSelected}
          value={dateSelected}
          disabledDate={current => current && current.valueOf() > moment().endOf("month")}
        />
      </div>
      {selectedFrequencyId === FREQUENCY_ID.QUARTERLY && (
        <div className="flex justify-center w-full mb-4">
          trimestre :{" "}
          {moment(dateSelected)
            .startOf("quarter")
            .format("MMMM")}{" "}
          -{" "}
          {moment(dateSelected)
            .endOf("quarter")
            .format("MMMM YYYY")}{" "}
        </div>
      )}
      <div className="flex justify-between items-center mb-4">
        <div className="">Montant : (€)</div>
        <InputNumber
          style={{ backgroundColor: "#f0f0f0", borderRadius: "11px", borderColor: "#f0f0f0", width: "300px" }}
          min={0}
          value={amount}
          onChange={setAmount}
        />
      </div>
      {selectedTypeId === BONUS_TYPE_ID.EXTRA && (
        <div className="flex justify-between items-center mb-4">
          <div className="">Motif :</div>
          <Input
            style={{
              backgroundColor: "#f0f0f0",
              borderRadius: "11px",
              borderColor: "#f0f0f0",
              width: "300px"
            }}
            min={0}
            value={comment}
            onChange={item => {
              setComment(item.target.value);
            }}
          />
        </div>
      )}
      <div className="pt-6 flex justify-center mt-6">
        <ConfirmButton
          disabled={!user}
          label={`${action === "create" ? "Ajouter" : "Modifier"} la prime`}
          large={true}
          onClick={handleCreateUpdatePremium}
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    userClientsIds: !isEmpty(state.userInfos.clients) ? state.userInfos.clients.map(item => item.id) : null,
    userRoleId: state.userInfos.role_id,
    token: state.auth.token,
    usersSectors: state.usersSectors && state.usersSectors.usersSectorsList
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getUsersSectors: params => {
      dispatch(fetchUsersSectors(params));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PremiumForm);



// WEBPACK FOOTER //
// src/containers/admin/premium/Premium.form.js